import { formatOptions } from 'components/formInputs/SelectField/utils';
import range from 'utils/range';

import { DiabetesFormValues } from './types';

export const LABELS: Record<keyof DiabetesFormValues, string> = {
  diagnosedAt: 'When were you diagnosed with diabetes?',
  diabetesType: 'Is this type 1 or type 2 diabetes?',
  gestational: 'Was the diagnosis for gestational diabetes?',
  lastA1cReading: 'What was your last A1C reading?',
  twelveMonthAverageA1cReading: "What's your average A1C reading for the last 12 months?",
  hasHadComplications: 'Have you had any complications from diabetes?',
  currentlyTreated: 'Are you currently undergoing treatment for diabetes?',
  lastTreatmentDate: 'When did your treatment end?',
  insulinUnits: "What's your daily dosage of insulin units?",
};
export const diabetesTypeChoices = [
  { label: 'Type 1', value: 1 },
  { label: 'Type 2', value: 2 },
];

/*  These values are hardcoded because lodash range doesn't work with
    the 5.0 case (makes it "5") or the .1 step (makes it ~5.100...002). */
export const a1cRangeOptions = [
  { label: "Don't know", value: 0 },
  { label: '5.0', value: 5.0 },
  { label: '5.1', value: 5.1 },
  { label: '5.2', value: 5.2 },
  { label: '5.3', value: 5.3 },
  { label: '5.4', value: 5.4 },
  { label: '5.5', value: 5.5 },
  { label: '5.6', value: 5.6 },
  { label: '5.7', value: 5.7 },
  { label: '5.8', value: 5.8 },
  { label: '5.9', value: 5.9 },
  { label: '6.0', value: 6.0 },
  { label: '6.1', value: 6.1 },
  { label: '6.2', value: 6.2 },
  { label: '6.3', value: 6.3 },
  { label: '6.4', value: 6.4 },
  { label: '6.5', value: 6.5 },
  { label: '6.6', value: 6.6 },
  { label: '6.7', value: 6.7 },
  { label: '6.8', value: 6.8 },
  { label: '6.9', value: 6.9 },
  { label: '7.0', value: 7.0 },
  { label: '7.1', value: 7.1 },
  { label: '7.2', value: 7.2 },
  { label: '7.3', value: 7.3 },
  { label: '7.4', value: 7.4 },
  { label: '7.5', value: 7.5 },
  { label: '7.6', value: 7.6 },
  { label: '7.7', value: 7.7 },
  { label: '7.8', value: 7.8 },
  { label: '7.9', value: 7.9 },
  { label: '8.0', value: 8.0 },
  { label: '8.1', value: 8.1 },
  { label: '8.2', value: 8.2 },
  { label: '8.3', value: 8.3 },
  { label: '8.4', value: 8.4 },
  { label: '8.5', value: 8.5 },
  { label: '8.6', value: 8.6 },
  { label: '8.7', value: 8.7 },
  { label: '8.8', value: 8.8 },
  { label: '8.9', value: 8.9 },
  { label: '9.0', value: 9.0 },
  { label: '9.1', value: 9.1 },
  { label: '9.2', value: 9.2 },
  { label: '9.3', value: 9.3 },
  { label: '9.4', value: 9.4 },
  { label: '9.5', value: 9.5 },
  { label: '9.6', value: 9.6 },
  { label: '9.7', value: 9.7 },
  { label: '9.8', value: 9.8 },
  { label: '9.9', value: 9.9 },
  { label: '10.0', value: 10.0 },
  { label: '10.1', value: 10.1 },
  { label: '10.2', value: 10.2 },
  { label: '10.3', value: 10.3 },
  { label: '10.4', value: 10.4 },
  { label: '10.5', value: 10.5 },
  { label: '10.6', value: 10.6 },
  { label: '10.7', value: 10.7 },
  { label: '10.8', value: 10.8 },
  { label: '10.9', value: 10.9 },
  { label: '11.0', value: 11.0 },
  { label: '11.1', value: 11.1 },
  { label: '11.2', value: 11.2 },
  { label: '11.3', value: 11.3 },
  { label: '11.4', value: 11.4 },
  { label: '11.5', value: 11.5 },
  { label: '11.6', value: 11.6 },
  { label: '11.7', value: 11.7 },
  { label: '11.8', value: 11.8 },
  { label: '11.9', value: 11.9 },
  { label: '12.0', value: 12.0 },
];

const insulinUnitsNumbers = formatOptions(range(20, 200, 1));

export const insulinUnitsOptions = [
  { label: "I don't use insulin", value: 0 },
  ...insulinUnitsNumbers,
];
